import { environment } from '../../../environments/environment';

export class SETTINGS {
  public static CMS_API = environment.baseUrl; // don't change this.

  public static ACCESS_TOKEN = '%&^%^*@&*#';
  public static LOGGED_IN_USER = '#$%@^^%';

  public static KEYS = {
    SECRET: 'iIUsWtNZcf',
  };
}
